import {
  faCheckCircle,
  faEdit,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { TurnIndexContext } from "../../../contexts/general/TurnIndexContext";
import {
  SecurityContext,
  STATUS_ACTIVE,
} from "../../../contexts/security/SecurityContext";
import { useHistory } from "react-router-dom";
import ModalCreate from "./modals/ModalCreate";
import { UPDATE_PLANT_TURN, DELETE_PLANT_TURN } from "../../../js/permissions";
import moment from "moment";
import { FORMAT_APP } from "../../../js/constant";
import Schedule from "./Schedule";

const Index = () => {
  const [{ modalTurn, turns, pictures }, { checkDeleteTurn, setmodalTurn }] =
    useContext(TurnIndexContext);
  const [{ user }, { can }] = useContext(SecurityContext);
  let history = useHistory();
  return (
    <div className="container-fluid">
      {modalTurn.open && <ModalCreate />}

      <div className="flex justify-end">
        {can(UPDATE_PLANT_TURN) && (
          <div
            onClick={() => setmodalTurn({ ...modalTurn, open: true })}
            style={user.bg1}
            className="btn-default-create flex"
          >
            <span className="font-title">Crear turno</span>
          </div>
        )}
      </div>
      <div>
        <table className="container-fluid standard-index-table">
          <thead>
            <tr style={user.cl2}>
              <td scope="col">Turno</td>
              <td scope="col">Descripción</td>
              <td scope="col">Editor</td>
              <td scope="col">Modificación</td>

              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {turns.elements.map((turn) => {
              return (
                <tr style={user.cl3} key={turn.id}>
                  <td className="txt-left">
                    {" "}
                    <FontAwesomeIcon
                      style={turn.status_id == STATUS_ACTIVE ? user.cl1 : ""}
                      icon={
                        turn.status_id == STATUS_ACTIVE
                          ? faCheckCircle
                          : faTimesCircle
                      }
                    />
                    &nbsp;{turn.name}
                  </td>
                  <td className="txt-left">{turn.description}</td>
                  <td className="txt-left">
                    {turn.end_updated ? (
                      <span>
                        {turn.end_updated.user.person.first_name}{" "}
                        {turn.end_updated.user.person.last_name}
                      </span>
                    ) : (
                      <span>
                        {turn.creator && turn.creator.user.person.first_name}{" "}
                        {turn.creator && turn.creator.user.person.last_name}
                      </span>
                    )}
                  </td>
                  <td className="txt-left">
                    {moment(turn.updated_at).format(FORMAT_APP)}
                  </td>
                  <td>
                    <div className="flex">
                      {can(UPDATE_PLANT_TURN) && (
                        <FontAwesomeIcon
                          onClick={() =>
                            setmodalTurn({
                              ...modalTurn,
                              open: true,
                              turn: turn,
                            })
                          }
                          style={user.cl1}
                          className="cursor-pointer"
                          icon={faEdit}
                        />
                      )}
                      &nbsp;
                      {can(DELETE_PLANT_TURN) && (
                        <FontAwesomeIcon
                          style={user.cl1}
                          className="cursor-pointer"
                          onClick={() => checkDeleteTurn(turn.id)}
                          icon={faTimesCircle}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Index;
